module.exports = __webpack_public_path__ + "static/media/sf-test-4.56787bda.mp3";